var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBalloon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 25.4099C10 25.4099 19.7505 15.9414 19.7505 10.4804C19.7505 7.85725 18.7232 5.34156 16.8946 3.4867C15.0661 1.6318 12.5859 0.589844 9.99975 0.589844C7.41362 0.589844 4.93358 1.63185 3.10494 3.4867C1.27625 5.34161 0.249023 7.85715 0.249023 10.4804C0.249023 15.9336 9.99951 25.4099 9.99951 25.4099H10ZM6.37891 9.43466C6.37891 8.48314 6.75144 7.57074 7.41469 6.89793C8.07793 6.22513 8.97768 5.84711 9.91571 5.84711C10.8536 5.84711 11.7533 6.22517 12.4166 6.89793C13.0798 7.57069 13.4524 8.48314 13.4524 9.43466C13.4524 10.3862 13.0798 11.2986 12.4166 11.9714C11.7533 12.6441 10.8536 13.0222 9.91571 13.0222C8.97763 13.0222 8.07793 12.6442 7.41469 11.9714C6.75144 11.2986 6.37891 10.3862 6.37891 9.43466Z",
    fill: "#1C1C1F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloon);
export default __webpack_public_path__ + "static/media/balloon.5534636d06bf30893b7e7424d2c91dd4.svg";
export { ForwardRef as ReactComponent };